import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { Typography, styled } from "@mui/material";
import List from "@mui/material/List";

const TopHeading = styled(Typography)({
  width: "100%",
  textAlign: "center",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
});

const TopBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 10,
});

const ButtonBox = styled(Box)({
  cursor: "pointer",
  padding: 2,
});
export default function CustomDrawer({
  children,
  onClose,
  hasHeader = true,
  maxWidth = 708,
}) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: true,
  });

  return (
    <div>
      {["left", "right", "top", "bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={onClose}
          >
            <Box
              sx={{
                width:
                  anchor === "top" || anchor === "bottom" ? "auto" : maxWidth,
                padding: 2,
                paddingTop: 0,
              }}
              role="presentation"
            >
              {hasHeader && (
                <TopBox>
                  <ButtonBox
                    onClick={() => {
                      // toggleDrawer(anchor, false);
                      onClose();
                    }}
                  >
                    <i className="fa fa-times"></i>
                  </ButtonBox>
                  <TopHeading>Select Dishes</TopHeading>
                </TopBox>
              )}
              {children}
            </Box>
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
